import React from 'react';
import QRCode from 'qrcode.react';
import './style.less';

interface QrcodeContainerProps {
  qrcode: string,
}

const clsPrefix = 'qrcode-container'
const QrcodeContainer:React.FC<QrcodeContainerProps> = ({
  qrcode
}) => {
  return (
    <div className={clsPrefix}>
      <div className={`${clsPrefix}__left-top`}>
        <div className={`${clsPrefix}__corner-two`}></div>
        <div className={`${clsPrefix}__corner-one`}></div>
      </div>
      <div className={`${clsPrefix}__right-top`}>
        <div className={`${clsPrefix}__corner-one`}></div>
        <div className={`${clsPrefix}__corner-two`}></div>
      </div>
      <div className={`${clsPrefix}__left-bottom`}>
        <div className={`${clsPrefix}__corner-two`}></div>
        <div className={`${clsPrefix}__corner-one`}></div>
      </div>
      <div className={`${clsPrefix}__right-bottom`}>
        <div className={`${clsPrefix}__corner-one`}></div>
        <div className={`${clsPrefix}__corner-two`}></div>
      </div>
      <div className={`${clsPrefix}__qrcode`}>
        {
          qrcode ? <QRCode style={{ width: '110px', height: '110px' }} value={qrcode} /> : 
          <div className={`${clsPrefix}__empty`}>
            暂无二维码
          </div>
        }
      </div>
    </div>
  )
}

export default QrcodeContainer;